import { InputText } from "components/forms/InputText";
import { Sizes } from "components/forms/NumberSelector";
import { useDialog } from "hooks/useDialog";
import { useCallback, useState } from "react";
import { tenantsAPI } from "services/swagger-api";

export const useTenantFormActions = ({
  refreshTenants,
}: { refreshTenants?: () => void }) => {
  const { openDialog, closeDialog, setDialogActions } = useDialog()
  const [checkoutDate, setCheckoutDate] = useState<string>()

  const handleDelete = useCallback(async (tenantId: string): Promise<void> => {
    await tenantsAPI.deleteTenantById({ tenantId })
    refreshTenants && refreshTenants()
  }, [refreshTenants]);

  const handleTenantCheckOut = useCallback(async (tenantId: string): Promise<void> => {
    openDialog({
      title: 'Date de sortie du locataire',
      size: Sizes['2xl']
    }, <div>
      <InputText
        type="date"
        onChange={(e) => setCheckoutDate(e.target.value)}
      />
    </div>)
    setDialogActions({
      onSubmit: async () => {
        if (checkoutDate) {
          // Date calendaire : string "yyyy-MM-dd" du picker, jamais de Date sérialisé
          await tenantsAPI.updateCheckoutDate({ tenantId, patchTenantCheckoutDateCommand: { checkOutDate: checkoutDate } })
          refreshTenants && refreshTenants()
          closeDialog()
        }
      },
      submitLabel: "COMMON.VALIDATE",
      closeLabel: "COMMON.CANCEL",
    });
  }, [refreshTenants, closeDialog, setDialogActions, openDialog, checkoutDate]);

  const handleDeleteWithConfirmation = useCallback(async (tenantId: string): Promise<void> => {
    openDialog({
      title: 'Suppression du locataire',
      size: Sizes['2xl']
    }, <div>
      Êtes-vous sûr de vouloir supprimer le locataire ?
    </div>)
    setDialogActions({
      onSubmit: () => {
        handleDelete(tenantId)
        closeDialog()
      },
      submitLabel: "COMMON.DELETE",
      closeLabel: "COMMON.CANCEL",
    });
  }, [openDialog, closeDialog, setDialogActions, handleDelete]);

  return {
    handleDelete,
    handleDeleteWithConfirmation,
    handleTenantCheckOut
  };
};
